export function pixelsToVh(pixels, windowHeight) {
    return (pixels / windowHeight) * 100;
}